var _path, _rect, _path2, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _rect3, _rect4, _rect5, _polygon3, _circle, _circle2, _polygon4, _path13, _rect6, _rect7, _rect8, _polygon5, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVazio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 885.55805,
    height: 557.51874,
    viewBox: "0 0 885.55805 557.51874",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heavy_box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M838.81222,592.35166C875.238,501.28427,864.21905,399.5975,817.23963,321.5L325.46637,389.59166l471.2759-98.21687c-198.62291-247.68466-585.21339-83.39849-547.948,229.321Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.75322,
    y: 320.44454,
    width: 626.52594,
    height: 195.09542,
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408.706,467.89305c5.62128,4.36531,7.67682,5.77455,8.8739,5.59569,57.99957,16.88979,7.15438,36.68334-21.02622,3.08454Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "60.099 475.093 60.099 514.747 88.649 513.161 80.719 471.921 60.099 475.093",
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.713 475.093 218.713 514.747 190.162 513.161 198.093 471.921 218.713 475.093",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.69608,441.72171l42.82582-1.58614c98.7937,103.57113,61.43194,79.94854,58.68724,222.05982L337.86647,646.334l11.103-98.34078c.00564-.00376,2.9288-1.95254.499-1.99746-15.19648,5.22229-26.2843-59.43676-59.18629-51.93136-37.44073-1.791-43.536,53.75037-58.68724,53.92882L242.698,646.334,190.3553,662.19539c-5.8605-156.16587-34.583-120.8878,58.68724-222.05982Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.25041,673.29838s-6.34456-12.68913-14.27527-6.34456-26.96441,25.37826-26.96441,25.37826-45.99811,20.61985-17.44756,33.309,52.34268-17.44756,52.34268-17.44756c27.194-5.67065,42.87962-9.3011,28.45819-38.964C239.17643,672.77254,227.58972,676.87439,225.25041,673.29838Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M368.00316,673.29838s6.34456-12.68913,14.27527-6.34456,26.96441,25.37826,26.96441,25.37826,45.99811,20.61985,17.44756,33.309-52.34268-17.44756-52.34268-17.44756c-27.194-5.67065-42.87962-9.3011-28.45819-38.964C354.07714,672.77254,365.66385,676.87439,368.00316,673.29838Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5219,262.48771c-2.35907,39.4855-56.24811,36.00919-57.10087-.00032C276.77987,223.0022,330.66891,226.47851,331.5219,262.48771Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.28222,283.10755c13.87587,41.93775-18.88432,19.10541,26.96441,52.34267l17.44755-34.89511s-12.68913-4.75843-11.103-22.206Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M375.93387,306.89967,328.65153,296.1074c1.32987,28.5097-29.09516,22.7717-34.404,8.43062l-45.205,26.15378c18.97388,70.667,14.16522,73.58277-11.103,118.96062-9.64336,8.806,4.77846,13.85306,17.33355,9.03441,9.576-5.91024,14.43914-11.16237,24.7-9.82589,48.48518,10.0956,88.84834,12.47853,95.23609,8.53366C377.49493,454.12327,375.143,307.46755,375.93387,306.89967Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#575a89"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M363.24473,310.072c1.58614,0,9.7566-3.84164,9.7566-3.84164,23.771-.40071,39.72292,159.49664,40.99993,164.04194l-15.86141,11.103-25.37827-65.03181Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#575a89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.21482,495.65052c.811,5.98616,2.1911,73.21058,26.27252,41.80855,3.15944-22.91-7.58221-29.74918-10.4111-44.98083Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.55939,330.6918l-4.85992-2.69431c-13.02929-.42812-8.923,34.06114-14.43543,59.31894-4.50341,29.42466-3.22115,61.86983,2.06236,105.24733.46205,15.91777,28.9725,5.88989,33.0944,4.67291,0,0-9.51685-65.03181-4.75842-76.1348S258.55939,330.6918,258.55939,330.6918Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#575a89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M330.274,234.81036a34.02906,34.02906,0,0,0-19.357-14.798l-5.91821,4.73455,2.3009-5.52232a31.326,31.326,0,0,0-5.84937-.33807l-5.32488,6.84631,2.20389-6.6118c-22.84908,2.4534-36.36771,28.68323-24.50556,47.04084,1.82984-5.62323,4.05069-10.89971,5.88053-16.523a16.64409,16.64409,0,0,0,4.33558.02112l2.22628-5.19453.62186,4.97483c6.90017-.60122,17.13483-1.921,23.67647-3.13031l-.63606-3.81638,3.80566,3.17141c2.00423-.46143,3.19416-.87977,3.09583-1.19955,4.86513,7.84319,9.68573,12.8528,14.55074,20.69594C333.22749,254.09835,336.48772,244.9024,330.274,234.81036Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 527.41215,
    y: 343.97895,
    width: 138.36733,
    height: 65.63579,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 553.57776,
    y: 357.72699,
    width: 86.0361,
    height: 7.8701,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 553.57776,
    y: 372.8618,
    width: 86.0361,
    height: 7.8701,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 553.57776,
    y: 387.9966,
    width: 86.0361,
    height: 7.8701,
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.916 359.57 402.415 351.775 397.915 343.979 393.414 351.775 388.913 359.57 393.749 359.57 393.749 382.144 402.08 382.144 402.08 359.57 406.916 359.57",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 711.88818,
    cy: 483.13309,
    r: 37.06013,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 718.62639,
    cy: 483.13309,
    r: 16.42438,
    fill: "#e6e6e6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "688.515 509.033 769.374 542.724 766.847 550.726 720.311 545.461 641.558 510.507 685.356 515.561 688.515 509.033",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M917.21059,712.44674l100.56476-329.88689,24.49016-43.49091.086-.4197c.079-.38371,1.877-9.47416-2.54574-16.05732a14.41879,14.41879,0,0,0-9.7384-6.13447c-13.51631-2.53423-43.75393-3.78284-45.0342-3.83486l-.24142-.00987-.23935.03269c-.82624.11269-20.15088,2.93748-24.51936,19.8122l-21.0244,38.2637-.08267.27226L843.74876,683.899l5.2379,1.59325,95.0945-312.63319,21.09473-38.39264.08555-.35286c3.089-12.6985,17.85682-15.66929,19.821-16.00921,3.089.13181,31.50885,1.39646,43.9756,3.73411a9.02851,9.02851,0,0,1,6.19122,3.7888c2.72588,4.03618,2.04358,9.97879,1.8034,11.541l-24.34,43.22463-.08719.28521L911.97351,710.8502Z",
    transform: "translate(-157.22097 -171.24063)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 965.00564,
    y: 374.70786,
    width: 5.47477,
    height: 73.80538,
    transform: "translate(233.46313 1119.54727) rotate(-79.76214)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 951.12147,
    y: 420.40497,
    width: 5.47474,
    height: 73.59863,
    transform: "translate(157.9235 1129.12816) rotate(-78.46469)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 925.90857,
    y: 503.38544,
    width: 5.47463,
    height: 73.22959,
    transform: "translate(-3.20879 1113.0217) rotate(-74.03214)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "784.589 511.372 786.585 506.273 718.249 479.515 714.893 443.181 778.675 467.004 799.338 496.902 803.843 493.79 782.201 462.476 708.64 435 713.108 483.382 784.589 511.372",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.32876,
    cy: 518.50867,
    r: 37.06013,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.01493,
    cy: 520.19322,
    r: 16.42438,
    fill: "#e6e6e6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVazio);
export default __webpack_public_path__ + "static/media/vazio.c5dbd27b78de4a8b585c16cddd3b34da.svg";
export { ForwardRef as ReactComponent };